/**
 * Auto-generated feature flag registry.
 *
 * This file is auto-generated from Flipt flag definitions
 * via the codegen script (scripts/generate-registry.ts).
 *
 * DO NOT EDIT MANUALLY — changes will be overwritten.
 *
 * To add a new flag:
 * 1. Define it in the Flipt dashboard
 * 2. Run: pnpm --filter @zep/feature-flag generate
 */

import type { FlagMetadata } from './types';

/**
 * All known feature flag keys, keyed by their identifier.
 * This const object provides compile-time validation of flag keys.
 */
export const FLAG_KEYS = {
  // --- core ---
  PHASER_V4_UPGRADE: {
    key: 'phaser-v4-upgrade',
    name: 'Phaser V4 Upgrade',
    type: 'BOOLEAN_FLAG_TYPE',
    namespace: 'core',
    description:
      'Phaser 3→4 엔진 업그레이드 롤아웃 제어. 내부 테스터부터 점진적 확대.',
  },
  // --- quiz ---
  QUIZ_PRICING_GROUP_PROFILE: {
    key: 'quiz-pricing-group-profile',
    name: 'Quiz Pricing Group Profile',
    type: 'VARIANT_FLAG_TYPE',
    namespace: 'quiz',
    description:
      '국가별 프라이싱 학교·단체 탭의 표시 콘텐츠 프로필 예시입니다. attachment는 앱에서 스키마 검증 후 렌더링합니다.',
  },
  QUIZ_PRICING_GROUP_TAB: {
    key: 'quiz-pricing-group-tab',
    name: 'quiz_pricing_group_tab',
    type: 'BOOLEAN_FLAG_TYPE',
    namespace: 'quiz',
    description:
      '퀴즈 가격 안내 페이지의 학교·단체 탭 및 전용 콘텐츠 노출 국가를 제어합니다.',
  },
} as const;

/**
 * Union type of all valid flag key strings.
 * Used to restrict hook/evaluation calls to known flags only.
 */
export type FlagKey = (typeof FLAG_KEYS)[keyof typeof FLAG_KEYS]['key'];

/** All flag metadata entries, derived from FLAG_KEYS to stay in sync. */
export const FLAG_METADATA: readonly FlagMetadata[] = Object.values(FLAG_KEYS);

/** Map of flag key -> metadata for O(1) lookup. */
export const FLAG_METADATA_MAP: Readonly<Record<FlagKey, FlagMetadata>> =
  Object.fromEntries(FLAG_METADATA.map(m => [m.key, m])) as Record<
    FlagKey,
    FlagMetadata
  >;
